class SectionFaqsSwatches extends HTMLElement {
    constructor() {
      super();
      this.tabheading = this.querySelectorAll('.tabheading_btn');
      this.tabdetails = this.querySelectorAll('.faq-Faqs_ColumnWrapper');
      this.tabContents = this.querySelector('.faq-Faqs_tabContents');
      this.flickityInstance = null;
  
      if (!this.tabheading.length) return;
  
      this.init();
    }
  
    init() {
      // Set up tab click handlers
      this.tabheading.forEach((tab, i) => {
        const tabContentId = tab.getAttribute('data-id');
        const tabContentEle = this.querySelector(`#${tabContentId}`);
        tab.addEventListener("click", (e) => this.onTabClick(e, tabContentEle));
        console.log("tabContentEletabContentEle") , tabContentEle
        this.initFaqs(tabContentEle);
      });

      // Initialize Flickity after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.initFlickity();
      }, 100);

      // Handle resize
      window.addEventListener('resize', () => {
        if (this.flickityInstance) {
          this.flickityInstance.resize();
        }
      });
    }

    initFlickity() {
  if (!this.flickityInstance && this.tabContents) {
    try {
      const isDesktop = window.innerWidth > 900;

      if (isDesktop) {
        // Hide all but the first tab on desktop
        this.tabdetails.forEach((item, i) => {
          item.style.display = 'none';
        });
        
        // Show the first tab
        const activeIndex = 0;
        const activeItem = this.tabdetails[activeIndex];
        activeItem.style.display = 'flex';

        // Click handlers for tabs
        this.tabheading.forEach((tab, i) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();

            this.tabdetails.forEach((item, index) => {
              if (index === i) {
                item.style.display = 'flex';
              } else {
                item.style.display = 'none';
              }
            });

            this.tabheading.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
          });
        });

      } else {
        // For mobile view, Flickity slider
        const options = {
          cellSelector: '.faq-Faqs_ColumnWrapper',
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true,
          cellAlign: 'left',
          contain: true,
          transitionDuration: 300
        };

        this.flickityInstance = new Flickity(this.tabContents, options);
        const activeIndex = Array.from(this.tabheading).findIndex(tab => tab.classList.contains('active'));
        if (activeIndex !== -1) {
          this.flickityInstance.select(activeIndex);
        }

        this.flickityInstance.on('change', (index) => {
          this.tabheading.forEach((tab, i) => {
            if (i === index) {
              tab.classList.add('active');
            } else {
              tab.classList.remove('active');
            }
          });
        });
      }

      // Handle resize
      window.addEventListener('resize', () => {
        const newIsDesktop = window.innerWidth > 900;
        if (newIsDesktop !== isDesktop) {
          // Destroy Flickity if switching to desktop
          if (this.flickityInstance) {
            this.flickityInstance.destroy();
            this.flickityInstance = null;
          }
          // Reinitialize
          this.initFlickity();
        } else if (this.flickityInstance) {
          this.flickityInstance.resize();
        }
      });

    } catch (error) {
      console.error('Error initializing:', error);
    }
  }
}


    onTabClick(event, tabContentEle) {
      event.preventDefault();
      const index = Array.from(this.tabdetails).indexOf(tabContentEle);
      if (this.flickityInstance) {
        this.flickityInstance.select(index);
      }
    }

    initFaqs(accordion){
      const items = accordion.querySelectorAll('[data-el="accordion.item"]');
      const triggers = accordion.querySelectorAll('[data-el="accordion.trigger"]');
      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          const item = items[index];
          const body = item.querySelector('[data-el="accordion.body"]');
          const isOpen = item.getAttribute('aria-expanded') === 'true';
          item.setAttribute('aria-expanded', !isOpen);
          body.classList.toggle('open', !isOpen);
          
          // Resize Flickity after accordion animation completes
          setTimeout(() => {
            if (this.flickityInstance) {
              this.flickityInstance.resize();
            }
          }, 100);
        });
      });
    }
}
  
customElements.define('faqs-swatches', SectionFaqsSwatches);

document.addEventListener("DOMContentLoaded", function () {
  var leftColumns = document.querySelectorAll('.faq-Faqs_Items.left');
  
  leftColumns.forEach(function (leftColumn) {
    if (leftColumn.children.length === 0) {
      leftColumn.style.display = 'none'; // Hide the left column
    }
  });
  const container = document.querySelector('.sec-faqs-and-swathces_inner');

if (container && container.querySelector('.sec-swatches')) {
  const columnWrappers = container.querySelectorAll('.faq-Faqs_ColumnWrapper');
  
  columnWrappers.forEach(function(wrapper) {
    wrapper.style.flexDirection = "column";
    wrapper.style.gap="0px"
  });
}

});

  




